import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import ImageUpload from "./ImageUpload";

const Block1 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
  selectedSize,
}) => {
  const [selectedImages, setSelectedImages] = useState("");
  const [BlobImage, setBlobImage] = useState("");

  const [ShowCropIcon, setShowCropIcon] = useState(false)
  const [EnableCroping, setEnableCroping] = useState(false)
  const [ResetZoom, setResetZoom] = useState(false)

  useEffect(() => {
    if (addToCartTriggered) {
      capture();
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    console.log(selectedImages);
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);
 
  const handleImageChange = (imagePreview) => {
    // console.log(imagePreview);
    setSelectedImages([imagePreview]);
    setShowCropIcon(true)
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      // setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-40 images-12-12">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center align-items-center">
            <div
              className={`number-line singlecanva ${selectedSize?.size
                .replace(/["']/g, "")
                .replace(/\s/g, "_")
                .replace(/^(\d+)/, "s$1")}`}
            >
              {/* <span>
                {selectedSize?.size === '6" X 8"'
                  ? '8"'
                  : selectedSize?.size === '8" X 8"'
                  ? '8"'
                  : selectedSize?.size === '8" X 10"'
                  ? '10"'
                  : selectedSize?.size === '10" X 10"'
                  ? '10"'
                  : selectedSize?.size === '11" X 14"'
                  ? '14"'
                  : selectedSize?.size === '16" X 16"'
                  ? '16"'
                  : selectedSize?.size === '16" X 20"'
                  ? '20"'
                  : selectedSize?.size === '20" X 20"'
                  ? '20"'
                  : selectedSize?.size === '20" X 24"'
                  ? '24"'
                  : selectedSize?.size === '24" X 36"'
                  ? '36"'
                  : selectedSize?.size === '30" X 40"'
                  ? '40"'
                  : selectedSize?.size === '36" X 9"'
                  ? '9"'
                  : selectedSize?.size === '36" X 36"'
                  ? '36"'
                  : selectedSize?.size === '36" X 48"'
                  ? '48"'
                  : selectedSize?.size === '40" X 60"'
                  ? '60"'
                  : selectedSize?.size === '48" X 12"'
                  ? '12"'
                  : selectedSize?.size === '60" X 15"'
                  ? '15"'
                  : selectedSize?.size === '72" X 19"'
                  ? '19"'
                  : ""}
              </span> */}
            </div>
            <div className="d-flex" id="captureArea">
              <div class="frame-left signle-shadow">
                <ImageUpload
                  defaultImage={
                    selectedSize?.size === '6" X 8"'
                      // ? "assets/img/breadcrumb/single-6-8.svg"
                      ? "assets/img/breadcrumb/new single img1.svg"
                      : selectedSize?.size === '8" X 8"'
                      // ? "assets/img/breadcrumb/single-8-8.svg"
                      ? "assets/img/breadcrumb/new single img2.svg"
                      : selectedSize?.size === '8" X 10"'
                      // ? "assets/img/breadcrumb/single-8-10.svg"
                      ? "assets/img/breadcrumb/new single img3.svg"
                      : selectedSize?.size === '10" X 10"'
                      // ? "assets/img/breadcrumb/single-10-10.svg"
                      ? "assets/img/breadcrumb/new single img1.svg"
                      : selectedSize?.size === '11" X 14"'
                      // ? "assets/img/breadcrumb/single-11-14.svg"
                      ? "assets/img/breadcrumb/new single img2.svg"
                      : selectedSize?.size === '16" X 16"'
                      // ? "assets/img/breadcrumb/single-16-16.svg"
                      ? "assets/img/breadcrumb/new single img3.svg"
                      : selectedSize?.size === '16" X 20"'
                      // ? "assets/img/breadcrumb/single-16-20.svg"
                      ? "assets/img/breadcrumb/new single img1.svg"
                      : selectedSize?.size === '20" X 20"'
                      // ? "assets/img/breadcrumb/single-20-20.svg"
                      ? "assets/img/breadcrumb/new single img2.svg"
                      : selectedSize?.size === '20" X 24"'
                      // ? "assets/img/breadcrumb/single-20-24.svg"
                      ? "assets/img/breadcrumb/new single img3.svg"
                      : selectedSize?.size === '24" X 36"'
                      // ? "assets/img/breadcrumb/single-24-36.svg"
                      ? "assets/img/breadcrumb/new single img1.svg"
                      : selectedSize?.size === '30" X 40"'
                      // ? "assets/img/breadcrumb/single-30-40.svg"
                      ? "assets/img/breadcrumb/new single img2.svg"
                      : selectedSize?.size === '36" X 9"'
                      // ? "assets/img/breadcrumb/single-36-9.svg"
                      ? "assets/img/breadcrumb/new single img3.svg"
                      : selectedSize?.size === '36" X 36"'
                      // ? "assets/img/breadcrumb/single-36-36.svg"
                      ? "assets/img/breadcrumb/new single img1.svg"
                      : selectedSize?.size === '36" X 48"'
                      // ? "assets/img/breadcrumb/single-36-48.svg"
                      ? "assets/img/breadcrumb/new single img2.svg"
                      : selectedSize?.size === '40" X 60"'
                      // ? "assets/img/breadcrumb/single-40-60.svg"
                      ? "assets/img/breadcrumb/new single img3.svg"
                      : selectedSize?.size === '48" X 12"'
                      // ? "assets/img/breadcrumb/single-48-12.svg"
                      ? "assets/img/breadcrumb/new single img1.svg"
                      : selectedSize?.size === '60" X 15"'
                      // ? "assets/img/breadcrumb/single-60-15.svg"
                      ? "assets/img/breadcrumb/new single img2.svg"
                      : selectedSize?.size === '72" X 19"'
                      // ? "assets/img/breadcrumb/single-72-19.svg"
                      ? "assets/img/breadcrumb/new single img3.svg"
                      : "assets/img/blog/thumb.png"
                  }
                  onChange={(e) => {
                    handleImageChange(e);
                  }}
                  className={
                    selectedSize?.size === '6" X 8"'
                      ? "single-6-8 last-seven-collage"
                      : selectedSize?.size === '8" X 8"'
                      ? "single-8-8 last-seven-collage"
                      : selectedSize?.size === '8" X 10"'
                      ? "single-8-10 last-seven-collage"
                      : selectedSize?.size === '10" X 10"'
                      ? "single-10-10 last-seven-collage"
                      : selectedSize?.size === '11" X 14"'
                      ? "single-11-14 last-seven-collage"
                      : selectedSize?.size === '16" X 16"'
                      ? "single-16-16 last-seven-collage"
                      : selectedSize?.size === '16" X 20"'
                      ? "single-16-20 last-seven-collage"
                      : selectedSize?.size === '20" X 20"'
                      ? "single-20-20 last-seven-collage"
                      : selectedSize?.size === '20" X 24"'
                      ? "single-20-24 last-seven-collage"
                      : selectedSize?.size === '24" X 36"'
                      ? "single-24-36 last-seven-collage"
                      : selectedSize?.size === '30" X 40"'
                      ? "single-30-40 last-seven-collage"
                      : selectedSize?.size === '36" X 9"'
                      ? "single-36-9 last-seven-collage"
                      : selectedSize?.size === '36" X 36"'
                      ? "single-36-36 last-seven-collage"
                      : selectedSize?.size === '36" X 48"'
                      ? "single-36-48 last-seven-collage"
                      : selectedSize?.size === '40" X 60"'
                      ? "single-40-60 last-seven-collage"
                      : selectedSize?.size === '48" X 12"'
                      ? "single-48-12 last-seven-collage"
                      : selectedSize?.size === '60" X 15"'
                      ? "single-60-15 last-seven-collage"
                      : selectedSize?.size === '72" X 19"'
                      ? "single-72-19 last-seven-collage"
                      : "single-6-8 last-seven-collage"
                  }
                  DataFrom="Single_Canvas"
                  CropEnable={EnableCroping}
                  resetzoom={ResetZoom}
                />
              </div>
            </div>
          </div>
          <div
            className={`number-line-2 singlecanva ${selectedSize?.size
              .replace(/["']/g, "")
              .replace(/\s/g, "_")
              .replace(/^(\d+)/, "s$1")}`}
          >
            {/* <span>
              {selectedSize?.size === '6" X 8"'
                ? '6"'
                : selectedSize?.size === '8" X 8"'
                ? '8"'
                : selectedSize?.size === '8" X 10"'
                ? '8"'
                : selectedSize?.size === '10" X 10"'
                ? '10"'
                : selectedSize?.size === '11" X 14"'
                ? '11"'
                : selectedSize?.size === '16" X 16"'
                ? '16"'
                : selectedSize?.size === '16" X 20"'
                ? '16"'
                : selectedSize?.size === '20" X 20"'
                ? '20"'
                : selectedSize?.size === '20" X 24"'
                ? '20"'
                : selectedSize?.size === '24" X 36"'
                ? '24"'
                : selectedSize?.size === '30" X 40"'
                ? '30"'
                : selectedSize?.size === '36" X 9"'
                ? '36"'
                : selectedSize?.size === '36" X 36"'
                ? '36"'
                : selectedSize?.size === '36" X 48"'
                ? '36"'
                : selectedSize?.size === '40" X 60"'
                ? '40"'
                : selectedSize?.size === '48" X 12"'
                ? '48"'
                : selectedSize?.size === '60" X 15"'
                ? '60"'
                : selectedSize?.size === '72" X 19"'
                ? '72"'
                : ""}
            </span> */}
            
            {ShowCropIcon && !EnableCroping && <div className="d-flex justify-content-between mt-3">
               <button className="mx-5 btn btn-sm btn-secondary" onClick={()=>{setEnableCroping(true);setResetZoom(false)}}>Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan <i class="fa fa-crop pointer" aria-hidden="true"></i></button>
            {/* <label className="mx-5 pointer">Reset</label> */}
            </div>}
            {EnableCroping && 
            <div className="d-flex justify-content-between mt-3">
              <div>
            <label className="mx-5 fw-bold align-items-baseline d-flex"> Crop <h6 className="fw-normal text-muted ms-4">Scroll to zomm and Drag to pan</h6></label>
              </div>
              <div className="mx-5">
         <button className="me-3 btn-sm btn btn-outline-dark" onClick={()=>{setEnableCroping(false);setResetZoom(true)}} >Reset</button>
         <button className="btn btn-secondary btn-sm" onClick={()=>setEnableCroping(false)}>Apply</button>
              </div>
         </div>}
          </div>
           
        </div>
      </div>
    </>
  );
};

const Default = () => {
  return (
    <div className="frame-container">
      <img
        src="assets/img/blog/thumb.png"
        alt=""
        style={{ objectFit: "contain", maxWidth: "100%" }}
      />
    </div>
  );
};

export default function CustomBlocksSingleCanvas({
  selectedSize,
  addToCartTriggered,
  sendAllSelectedImages,
  sendblobImage,
}) {
  const updateAllSelectedImages = (images) => {
    console.log(images);
    sendAllSelectedImages(images);
  };

  const SendBlobImage = (images) => {
    console.log(images);
    sendblobImage(images);
  };

  return (
    <>
      {selectedSize?.id ? (
        <Block1
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
          selectedSize={selectedSize}
        />
      ) : (
        <Default />
      )}
    </>
  );
}
